window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  document.addEventListener(
    "shopify:section:load",
    this._onSectionLoad.bind(this)
  );
  document.addEventListener(
    "shopify:section:unload",
    this._onSectionUnload.bind(this)
  );
  document.addEventListener(
    "shopify:section:select",
    this._onSelect.bind(this)
  );
  document.addEventListener(
    "shopify:section:deselect",
    this._onDeselect.bind(this)
  );
  document.addEventListener(
    "shopify:block:select",
    this._onBlockSelect.bind(this)
  );
  document.addEventListener(
    "shopify:block:deselect",
    this._onBlockDeselect.bind(this)
  );
};

theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var id = container.getAttribute("data-section-id");
    var type = container.getAttribute("data-section-type");

    constructor = constructor || this.constructors[type];

    if (typeof constructor === "undefined") {
      return;
    }

    var instance = Object.assign(new constructor(container), {
      id: id,
      type: type,
      container: container,
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function (evt) {
    var container = document.querySelector(
      '[data-section-id="' + evt.detail.sectionId + '"]'
    );

    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    this.instances = this.instances.filter(function (instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (typeof instance.onUnload === "function") {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onSelect === "function"
    ) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onDeselect === "function"
    ) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onBlockSelect === "function"
    ) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onBlockDeselect === "function"
    ) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor;

    document.querySelectorAll('[data-section-type="' + type + '"]').forEach(
      function (container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  },
});

/*///////////////////////////////////////////////
//           Customer tabs           //
/////////////////////////////////////////////*/

theme.customerTemplates = (function () {
  var selectors = {
    RecoverHeading: "#RecoverHeading",
    RecoverEmail: "#RecoverEmail",
    LoginHeading: "#LoginHeading",
  };

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function showRecoverPasswordForm() {
    document.getElementById("recover").classList.remove("hidden");
    document.getElementById("login").classList.add("hidden");
    // $('#recover').removeClass('hide');
    // $('#login').addClass('hide');
  }

  function hideRecoverPasswordForm() {
    document.querySelector("#recover").classList.add("hidden");
    document.querySelector("#login").classList.remove("hidden");
    // $('#RecoverPasswordForm').addClass('hide');
    // $('#CustomerLoginForm').removeClass('hide');
  }

  function customerAddressForm() {
    var newAddressForm = document.getElementById("AddressNewForm");
    var newAddressFormButton = document.getElementById("AddressNewButton");

    if (!newAddressForm) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(
        "AddressCountryNew",
        "AddressProvinceNew",
        {
          hideElement: "AddressProvinceContainerNew",
        }
      );
    }

    // Initialize each edit form's country/province selector
    document
      .querySelectorAll(".address-country-option")
      .forEach(function (option) {
        var formId = option.dataset.formId;
        var countrySelector = "AddressCountry_" + formId;
        var provinceSelector = "AddressProvince_" + formId;
        var containerSelector = "AddressProvinceContainer_" + formId;

        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
          hideElement: containerSelector,
        });
      });

    // Toggle new/edit address forms
    document.querySelectorAll(".address-new-toggle").forEach(function (button) {
      button.addEventListener("click", function () {
        var isExpanded =
          newAddressFormButton.getAttribute("aria-expanded") === "true";

        newAddressForm.classList.toggle("hide");
        newAddressFormButton.setAttribute("aria-expanded", !isExpanded);
        newAddressFormButton.focus();
      });
    });

    document
      .querySelectorAll(".address-edit-toggle")
      .forEach(function (button) {
        button.addEventListener("click", function (evt) {
          var formId = evt.target.dataset.formId;
          var editButton = document.getElementById("EditFormButton_" + formId);
          var editAddress = document.getElementById("EditAddress_" + formId);
          var isExpanded = editButton.getAttribute("aria-expanded") === "true";

          editAddress.classList.toggle("hide");
          editButton.setAttribute("aria-expanded", !isExpanded);
          editButton.focus();
        });
      });

    document.querySelectorAll(".address-delete").forEach(function (button) {
      button.addEventListener("click", function (evt) {
        var target = evt.target.dataset.target;
        var confirmMessage = evt.target.dataset.confirmMessage;

        // eslint-disable-next-line no-alert
        if (
          confirm(
            confirmMessage || "Are you sure you wish to delete this address?"
          )
        ) {
          Shopify.postLink(target, {
            parameters: { _method: "delete" },
          });
        }
      });
    });
  }

  /**
   *
   *  Check URL for reset password hash
   *
   */
  function checkUrlHash() {
    var hash = window.location.hash;

    // if (hash) {
    //   setTimeout(function() {
    //     window.scrollTo(0, 0);
    //   }, 1);
    // } else {
    //   setTimeout(function() {
    //     if (location.hash) {
    //       window.scrollTo(0, 0);
    //     }
    //   }, 5);
    // }

    // Allow deep linking to recover password form
    if (hash === "#recover") {
      window.scrollTo(0, 0);
      showRecoverPasswordForm.bind(this)();
    }

    // $('.js-recover-password-button').click((event) => {
    document
      .querySelectorAll(".js-recover-password-button")
      .forEach((button) => {
        button.addEventListener("click", (event) => {
          event.preventDefault();
          var hash = event.target.hash || "";
          if (hash === "#recover") {
            showRecoverPasswordForm.bind(this)();
          } else {
            hideRecoverPasswordForm.bind(this)();
          }

          window.scrollTo(0, 0);
          // window.location.hash = hash;

          // window.scrollTo(0, 0);
          // setTimeout(function() {
          //   window.scrollTo(0, 0);
          // }, 1);
        });

        // event.preventDefault();
        // var hash = event.target.hash || '';
        // window.location.hash = hash;

        // setTimeout(function() {
        //   window.scrollTo(0, 0);
        // }, 1);
      });
  }

  return {
    init: function () {
      checkUrlHash();
      customerAddressForm();
    },
  };
})();

theme.CustomerTabs = (function () {
  function Tabs() {
    const myTabs = document.querySelectorAll(".customer-tab");

    function myTabClicks(tabClickEvent) {
      if (
        tabClickEvent.currentTarget.classList.contains("customer-tab--recharge")
      ) {
        return;
      }

      for (let i = 0; i < myTabs.length; i++) {
        myTabs[i].classList.remove("is-active");
      }

      const clickedTab = tabClickEvent.currentTarget;
      clickedTab.classList.add("is-active");
      tabClickEvent.preventDefault();
      const myContentPanes = document.querySelectorAll(".customer-tab-content");

      for (let i = 0; i < myContentPanes.length; i++) {
        myContentPanes[i].classList.remove("is-active");
      }

      const anchorReference = tabClickEvent.target;
      const activePaneId = anchorReference.getAttribute("href");
      const activePane = document.querySelector(activePaneId);
      activePane.classList.add("is-active");
    }

    for (let i = 0; i < myTabs.length; i++) {
      myTabs[i].addEventListener("click", myTabClicks);
    }
  }

  return Tabs;
})();

window.theme = window.theme || {};

document.addEventListener("DOMContentLoaded", function () {
  var sections = new theme.Sections();

  sections.register("customer-tabs", theme.CustomerTabs);

  theme.customerTemplates.init();
});

/*///////  End of Customer tabs  ////////*/
